<template>
	
<div class="default-panel address-panel">
	<normalBar title="收货地址" :path="backPath"></normalBar>


	<div v-if="!loading" class="border">
		<div class="empty-sec" v-if="empty" v-cloak>
			当前暂无收货地址
		</div>


		<div class="address-list" v-show="!!addressList" ref="wrapper">

			<mt-loadmore 
		  				:bottom-method="bottomTop" 
		  				@bottom-status-change="handleBottomChange" 
		  				:bottom-all-loaded="allLoaded"
		  				:autoFill = "false"
	                	ref = "loadmore"
	  				>

				<mt-cell-swipe
					v-for=" (item,index) in addressList"
					:key="index"
				  	:right="[
				  		{
					      	content: '设为默认',
					      	style: { background: '#D4B675', color: '#fff' },
					      	handler: () => {setDefaultAddress(item.id,index)}
			    		},
					    {
					      content: '删除',
					      style: { background: '#D8331D', color: '#fff' },
					      handler: () => {	delAddress(item.id,index)  }
			    		}
		  			]"
		  			
		  		>
					<div class="address-sec"
						@click="checkedToAddress(item)"
						:class="{disabled: item.checkStatus == 0 && isOrderAddress}"
					>
						<div class="address-content">
							<p class="title" v-if="item.isDefault">默认地址</p>
							<p class="big-size">{{item.recipientName}}<span class="last">收</span></p>
							<p>{{item.address}}</p>
							<p class="phone">{{item.recipientMobile | filterPhone}}</p>
						</div>
						<div class="edite-group" @click.stop="goEdit(item.id)">
							<span class="icon-edite" ></span>
						</div>
					</div>
		  		</mt-cell-swipe>

		  		<div slot="bottom" class="mint-loadmore-bottom">
	                <span v-show="bottomStatus !== 'loading'" :class="{ 'rotate': bottomStatus === 'pull' }">上拉加载更多</span>
	              	<span v-show="bottomStatus === 'loading'">Loading...</span>
	            </div>
		  	</mt-loadmore>
		</div>
	</div>


	<router-link :to= "{ path: path, query: { url: isOrderAddress ? '/addressList?isOrderAddress=true' : this.$route.fullPath, isOrderAddress: isOrderAddress}}">
		<div class="empty-footer-sec">
			<span>+ </span> 新建地址
		</div>
	</router-link>

</div>

</template>

<script>
	import Vue from 'vue';
	import { CellSwipe } from '@/js/mint-ui';
	import { MessageBox } from '@/js/mint-ui';
	import { Loadmore } from '@/js/mint-ui';
	Vue.component(Loadmore.name, Loadmore);
	Vue.component(CellSwipe.name, CellSwipe);

	import normalBar from '@/components/common/navbar/normalBar'

	import { mapState} from 'vuex'
 
	export default {

		data(){
			return {
				loading: true,
				id: '',
				isOrderAddress: false,
       			path: '/addressEdit/add',
				bottomStatus: '',
        		allLoaded: false,
        		wrapperHeight: '600',
			}
		},
		computed: {
			...mapState({
				addressList: state => state.addressState.addressList,
				pageNo:  state => state.addressState.page,
				totalPage: state => state.addressState.totalPage
			}),
			empty(){
				return this.addressList.length > 0 ? false: true;
			},
      		backPath () {
		        if(this.$route.query.isOrderAddress){
		          return '/firmOrder?url=/ShoppingCart'
		        }
		        console.log(this.$route.query['url'])
		        return this.$route.query['url']
		    }
		},
		components: {
			normalBar
		},
		watch:{
			pageNo(val){
				if(val  >= this.totalPage) {
					this.allLoaded =  true; 
				}
			},
		},
		methods: {

			bottomTop() {
				this.getAddressList();
		        this.$refs.loadmore.onBottomLoaded();
		    },
	        handleBottomChange(status) {
	            this.bottomStatus = status;
	        },

			checkedToAddress(item){
				const { isOrderAddress } = this;
				if(item.checkStatus== 0) return false;
				console.log(item);
				if( !isOrderAddress) return false;
				let self = this;
				this.$store.dispatch('checkAddress',item).then(function(){
					self.$router.push({
						name: 'firmOrder',
						query: item
					})
				});
			},
			setDefaultAddress(id,index){
				let parma = {
					id: id,
					index: index
				}
				this.$store.dispatch('setDefaultAddress',parma)

			},
			delAddress(id,index){
				let self = this;
				
				let parma = {
					id: id,
					index: index
				}
				MessageBox.confirm('','',{
					message: '是否确认删除地址',
				}).then(function(action){
					self.$store.dispatch('delAddress',parma)
				},function(action){
					console.log(action);
				})
			
			},
			getAddressList(){
				let self = this;
				this.$store.dispatch('getAddressListManager',self.isOrderAddress).then(function(){
					self.loading = false;
					self.$nextTick(function(){
						self.wrapperHeight = document.documentElement.clientHeight - self.$refs.wrapper.getBoundingClientRect().top;
					})
				});
			},
			goEdit(id){
				let self = this;
				this.$router.push({
					path: '/addressEdit/edit/'+id,
					query:{
						url: self.isOrderAddress ? '/addressList?isOrderAddress=true': '/addressList'
					}
				})
			}
		},
		mounted(){

			this.isOrderAddress = (this.$route.query.isOrderAddress===true || this.$route.query.isOrderAddress ==='true') ? true : false;


		
		   if (this.utils.isWxLogin() === true && 
		  		(this.$store.state.user.userId === undefined || this.$store.state.user.mobilePhone.length < 10)) {
		    
		      	this.path = '/userAccountSet/bindMobilePhone?url='+this.$route.fullPath
     		}
			let self = this;
			this.$nextTick(function(){
				self.getAddressList()
			});
		},
		destroyed(){
			this.$store.dispatch('initPageNo');
		}

	}
</script>
<style lang="scss">
	@import '../../assets/css/mixin';
	
	.address-panel {
		.border {
			border-top: 1px solid #d4b675;
			margin-top: -1px;
		}

	}
	.empty-sec {
		padding: pxToRem(100px) 0;
		color: #666666;
		text-align: center;
	}
	.empty-footer-sec {
		padding: pxToRem(40px) 0;
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		background-color: #fff;
		font-size: pxToRem(28px);
		color: #D8331D;
		text-align: center;
		border-top: 1px solid #ccc;
	}

	.address-list {
		padding-left: pxToRem(50px);

		
		.mint-cell-wrapper {
			padding: 0;

			.mint-cell-title {
				display: none;
			}
		}

		.mint-cell-swipe {
			// border-bottom: 1px solid #ccc;
			
			.mint-cell-value {
				width: 100%;
			}
		}

		.address-sec {
			padding-left: 0;

			&.disabled {
				// background-color: rgba(0,0,0,.2);
				color: #ccc;
				.big-size {
					color: #ccc;
				}
			}
		}
		.mint-cell-swipe-buttongroup {
			display: flex;
		}

		.mint-cell-swipe-button {
			width: pxToRem(110px);
			vertical-align: top;
			color: #fff;
			line-height: 1.2em;
			text-align: center;
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}
	}

</style>


// WEBPACK FOOTER //
// addressList.vue?4be00ba2